(function () {
  var NAMESPACE = 'paypalMessages';
  var sdkLoading = false;
  var renderTimer = null;
  var sdkPollTimer = null;

  function getSdk() {
    return window[NAMESPACE];
  }

  function getConfig() {
    var script = document.querySelector('script[data-paypal-client-id]');
    if (!script) return null;

    return {
      clientId: script.getAttribute('data-paypal-client-id'),
      currency: script.getAttribute('data-paypal-currency'),
      locale: script.getAttribute('data-paypal-locale') || 'en_US',
    };
  }

  function isInClosedDrawer(el) {
    var drawer = el.closest('cart-drawer');
    return Boolean(drawer && !drawer.classList.contains('active'));
  }

  function hasNewMessageNode(mutation) {
    var nodes = mutation.addedNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType !== 1) continue;
      if (node.matches && node.matches('[data-pp-message], [data-paypal-messages]')) return true;
      if (node.querySelector && node.querySelector('[data-pp-message]')) return true;
    }
    return false;
  }

  function renderMessages() {
    var sdk = getSdk();
    if (!sdk || typeof sdk.Messages !== 'function') return false;

    document.querySelectorAll('[data-pp-message]').forEach(function (el) {
      if (isInClosedDrawer(el)) return;

      var amount = el.getAttribute('data-pp-amount') || '';
      if (!parseFloat(amount)) return;

      var rendered = el.getAttribute('data-pp-rendered');
      if (rendered === 'pending') return;
      if (rendered === 'true' && el.getAttribute('data-pp-rendered-amount') === amount) return;

      try {
        el.innerHTML = '';
        el.setAttribute('data-pp-rendered', 'pending');

        sdk
          .Messages({
            amount: parseFloat(amount),
            placement: el.getAttribute('data-pp-placement') || 'cart',
            style: {
              layout: el.getAttribute('data-pp-style-layout') || 'text',
              logo: {
                type: el.getAttribute('data-pp-style-logo-type') || 'inline',
              },
              text: {
                color: el.getAttribute('data-pp-style-text-color') || 'black',
                size: parseInt(el.getAttribute('data-pp-style-text-size') || '12', 10),
              },
            },
          })
          .render(el)
          .then(function () {
            el.setAttribute('data-pp-rendered', 'true');
            el.setAttribute('data-pp-rendered-amount', amount);
          })
          .catch(function () {
            el.removeAttribute('data-pp-rendered');
          });
      } catch (e) {
        el.removeAttribute('data-pp-rendered');
      }
    });

    return true;
  }

  function scheduleRender() {
    if (renderTimer) window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(function () {
      loadSdk(renderMessages);
    }, 150);
  }

  function waitForSdk(onReady, attempt) {
    attempt = attempt || 0;
    if (getSdk() && typeof getSdk().Messages === 'function') {
      onReady();
      return;
    }
    if (attempt > 50) return;
    if (sdkPollTimer) window.clearTimeout(sdkPollTimer);
    sdkPollTimer = window.setTimeout(function () {
      waitForSdk(onReady, attempt + 1);
    }, 100);
  }

  function loadSdk(onReady) {
    if (getSdk() && typeof getSdk().Messages === 'function') {
      if (onReady) onReady();
      return;
    }

    if (sdkLoading) {
      waitForSdk(onReady || renderMessages);
      return;
    }

    var config = getConfig();
    if (!config || !config.clientId || !config.currency) return;

    sdkLoading = true;

    var script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-namespace', NAMESPACE);
    script.src =
      'https://www.paypal.com/sdk/js?client-id=' +
      encodeURIComponent(config.clientId) +
      '&currency=' +
      encodeURIComponent(config.currency) +
      '&components=messages&locale=' +
      encodeURIComponent(config.locale);

    script.onload = function () {
      waitForSdk(function () {
        sdkLoading = false;
        (onReady || renderMessages)();
      });
    };
    script.onerror = function () {
      sdkLoading = false;
    };

    document.head.appendChild(script);
  }

  function setupListeners() {
    document.addEventListener('cart:change', scheduleRender);

    if (typeof subscribe === 'function') {
      subscribe('cart-update', scheduleRender);
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function (mutations) {
        if (!drawer.classList.contains('active')) return;

        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type === 'attributes') {
            scheduleRender();
            return;
          }
          if (mutation.type === 'childList' && hasNewMessageNode(mutation)) {
            scheduleRender();
            return;
          }
        }
      }).observe(drawer, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
    }
  }

  function init() {
    setupListeners();
    loadSdk(renderMessages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
